import uuid from "uuid/v4";

export const leftSideSpeaches = [
  {
    id: uuid(),
    href: 'https://youtu.be/iXFVV76YnRQ',
    title: 'Minas Testing Conference 2021'
  },
  {
    id: uuid(),
    href: 'https://youtu.be/7X8Fzl7rrjw',
    title: 'Test Automation Talks July 2021'
  },
  {
    id: uuid(),
    href: "https://youtu.be/TTay2ptoFoo",
    title: "Get Teknical - Junho de 2021"
  },
  {
    id: uuid(),
    href: "https://youtu.be/RCk3T0MZkUA",
    title: "Resenha de QAs - Junho de 2021"
  },
  {
    id: uuid(),
    href: "https://youtu.be/V6JE8YfsgcI",
    title: "GTS-BA Tech-talk - Abril de 2021"
  },
  {
    id: uuid(),
    href: "https://youtu.be/kYWRqBAV5Sk",
    title: "Gente da Qualidade #10 - Abril de 2021"
  },
  {
    id: uuid(),
    href: "https://youtu.be/o7eLdMLbGMw",
    title: "Ubitalks Abril de 2021",
  },
  {
    id: uuid(),
    href: "https://youtu.be/4bopG_hlr0I",
    title: "mais.dev - Junho de 2020"
  },
  {
    id: uuid(),
    href: "https://youtu.be/JhGyMydRexU",
    title: "Pessonizando - Junho de 2020"
  },
  {
    id: uuid(),
    href: "https://speakerdeck.com/wlsf82/a-importancia-da-mentoria-na-area-de-engenharia-de-software-e85659c1-d043-4143-bebe-ea0ebf4516e1",
    title: "Manaus Community XP 2020 "
  },
  {
    id: uuid(),
    href: "https://www.slideshare.net/walmyrlimasilvafilho/esquenta-qax",
    title: "Esquenta QAXperience 2020"
  },
  {
    id: uuid(),
    href: "https://www.slideshare.net/walmyrlimasilvafilho/agile-testing-a-quality-culture-in-the-companys-core-business",
    title: "Agile, Testing & DevOps Manchester 2020"
  },
  {
    id: uuid(),
    href: "https://www.slideshare.net/walmyrlimasilvafilho/how-to-kill-software-quality-in-five-steps",
    title: "Agile, Testing & DevOps Amsterdam 2020"
  },
];
